<template>
  <div>
    <div class="p-layout-breadcrumb">
      <el-row type="flex" align="middle">
        <el-col :span="3">
          <h3>首页版本设置</h3>
        </el-col>
        <el-col :span="2">
          <el-button type="info" @click="handleAdd">新建</el-button>
        </el-col>
      </el-row>
    </div>
    <el-table :data="fetchList">
      <el-table-column prop="version" label="版本号" width="180">
      </el-table-column>
      <el-table-column inline-template :context="_self" label="当前状态" width="180">
        <div v-if="global[0] && global[0].SettingValue">
          <span v-if="row.version === global[0].SettingValue[row.refer]" style="color:#67C23A;">激活中</span>
          <span v-else style="color:#999">未激活</span>
        </div>
      </el-table-column>
      <!-- <el-table-column inline-template :context="_self" label="客户端来源" width="180">

      </el-table-column> -->
      <el-table-column label="客户端来源" inline-template :context="_self">
          <span>{{referList[row.refer]}}</span>
      </el-table-column>
      <el-table-column prop="remark" label="版本名称">
      </el-table-column>
      <el-table-column label="创建时间" inline-template :context="_self">
        <span v-if="row.created">{{ new Date(row.created).getFullYear()+'-'+(new Date(row.created).getMonth()+1)+'-'+new Date(row.created).getDate()+' '+new Date(row.created).getHours()+':'+new Date(row.created).getMinutes()+':'+new Date(row.created).getSeconds()}} </span>
      </el-table-column>
      <el-table-column inline-template :context="_self" width="150" label="操作" align="right">
        <span v-if="global[0] && global[0].SettingValue">
                              <el-button type="text" size="small" v-if="row.version !== global[0].SettingValue[row.refer]" @click="handleLive($index, row)">激活</el-button>
                              <el-button @click="handleEdit($index, row)" type="text" size="small">编辑</el-button>
                              <el-button @click="handleDelete($index, row)" type="text" size="small" v-if="Role !== '0' && (row.version !== global[0].SettingValue)">删除</el-button>
                    </span>
      </el-table-column>
    </el-table>


    <el-dialog title="新建首页版本" v-model="addVersion">
      <el-form :model="versionForm" ref="versionForm" :rules="addVersionRules" label-width="120px">
        <el-form-item label="版本号" label-width="120px" prop="version">
          <el-input v-model="versionForm.version" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="版本名称" label-width="120px" prop="remark">
          <el-input v-model="versionForm.remark" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="客户端来源" label-width="120px" prop="remark">
          <el-select v-model="versionForm.refer" placeholder="请选择">
            <el-option
              v-for="item,key in referList"
              :key="key"
              :label="item"
              :value="key">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="基于某个版本" label-width="120px" prop="base">
          <el-select v-model="versionForm.base" placeholder="基于版本">
            <el-option v-for="item in versionOption" :key="item.id" :label="item.version" :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="submitForm('versionForm')">下一步</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>

    <el-dialog title="编辑首页版本" v-model="editVersion">
      <el-form :model="versionForm" ref="versionForm" :rules="addVersionRules" label-width="120px">
        <el-form-item label="版本号" label-width="120px" prop="version">
          <el-input v-model="versionForm.version" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="版本名称" label-width="120px" prop="remark">
          <el-input v-model="versionForm.remark" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="客户端来源" label-width="120px" prop="remark">
          <el-select v-model="versionForm.refer" placeholder="请选择">
            <el-option
              v-for="item,key in referList"
              :key="key"
              :label="item"
              :value="key">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="submitForm('versionForm')">下一步</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>

  </div>
</template>

<script>
  import {
    getVersions,
    getGlobalSettings,
    filterIndexVersions,
    postVersions,
    putGlobalSettings,
    deleteVersions
  } from '../../api/version'

  export default {
    data() {
      return {
        fetchList: [],
        global: [],
        Role: sessionStorage.power,
        referList: {
            global: '全部来源',
            wechat: '微信小程序',
            alipay: '支付宝小程序',
            h5: 'H5网页APP'
        },
        addVersionRules: {
          remark: [{
            required: true,
            message: '请输入版本名称',
            trigger: 'blur'
          }],
          version: [{
            required: true,
            message: '请输入版本号',
            trigger: 'blur'
          }]
        },
        userForm: {
          user: '1',
          role: ''
        },
        addVersion: false,
        editVersion: false,
        versionForm: {
          version: '',
          base: '',
          remark: ''
        },
        versionOption: []
      }
    },
    beforeCreate() {
      let localVersion = this.$store.state.currentIndex
      getVersions().then(data => {
        this.fetchList = data.data.filter(item => {
          if (item.version && item.version.indexOf('index') == 0) {
            return item
          }
        })
        if (localVersion.length) {
          this.fetchList.push(localVersion)
        }
      }, err => {
        console.log(err, 'xx')
      })

      getGlobalSettings().then(res => {
          res.data.forEach((item) => {
              if (item.SettingKey === 'home_version') {
                  item.SettingValue = JSON.parse(item.SettingValue);
              }
          })
        this.global = res.data;
      })

      filterIndexVersions().then(res => {
        this.versionOption = res.data
      })
    },
    methods: {
      handleEdit(index, row) {
        this.versionForm = Object.assign({}, row);
        this.editVersion = true
        console.log(row)
      },
      handleLive(index, row) {
        let data = {
          "SettingKey": 'home_version',
          "SettingValue": JSON.stringify(Object.assign(this.global[0].SettingValue, {
              [row.refer]: row.version
          }))
        }

        putGlobalSettings(sessionStorage.userId, data).then(res => {
          console.log(res.data)
          if (res.data.SettingKey) {
            this.$message({
              message: '成功激活',
              type: 'success'
            });
            this.global[0].SettingValue = JSON.parse(res.data.SettingValue);
          }
        }, err => {
          console.log(err)
        })
      },
      handleAdd() {
        this.versionForm = {
          version: '',
          base: '',
          remark: '',
          refer: ''
        }
        this.addVersion = true
      },
      handleDelete(index, row) {
        this.$confirm('此操作将永久删除该版本, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          console.log(row.id)
          deleteVersions(sessionStorage.userId, row.id).then(res => {
            console.log(res)
            this.$message({
              type: 'success',
              message: '删除成功!'
            });
            this.fetchList.splice(index, 1)
          }, err => {
            this.$message({
              type: 'info',
              message: '删除失败'
            });
          })

          // this.refresh()
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });
        });
      },
      handleCheck(val) {},
      submitForm(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            if (this.versionForm.value && this.versionForm.value.banner.length) {

            } else if (this.versionForm.base) {
              let nowId = this.versionForm.base
              this.versionOption.forEach(item => {
                console.log(item, 'gg')
                if (item.id === nowId) {
                  this.versionForm.value = item.value
                }
              })

            } else {
              this.versionForm.value = {
                banner: [],
                category: [],
                product: [],
                topic: []
              }
            }
            let nowData = JSON.parse(JSON.stringify(this.versionForm))
            nowData.base ? delete nowData.base : ''
            this.fetchList.push(this.versionForm)
            this.$store.commit('SETCURRENTINDEX', nowData);
            this.$router.push('banner')
          } else {
            console.log('error submit!!');
            return false;
          }
        });
      },
      resetForm(formName) {
        this.$refs[formName].resetFields();
      }
    }
  }
</script>



// WEBPACK FOOTER //
// IndexVersion.vue?69fb084a